import axios from '@/js/helper/axios-helper.js'
import { get } from 'lodash-es'
import { STORE_MODULES, APP_GETTER_TYPES, REQUEST_STATE, TYPES } from './std-imports'

export const getAvailabilityWatchActions = MUTATION_TYPES => ({
  [TYPES.AVAILABILITY_WATCH_REQUEST]: async (
    { state, commit, getters, rootGetters },
    { method = 'GET', data, url } = {},
  ) => {
    const resultUrl =
      url || rootGetters[`${STORE_MODULES.APP}/${APP_GETTER_TYPES.AVAILABILITY_WATCH_URL}`]

    if (!resultUrl) {
      // Todo: enable reject?
      return
      // return Promise.reject(new Error('availability watch url not found'))
    }

    if (getters[`${MUTATION_TYPES.AVAILABILITYWATCH.BASE}_${REQUEST_STATE.STATE_PENDING}`]) {
      await state[MUTATION_TYPES.AVAILABILITYWATCH.promiseKey]
    }

    const params = {
      method,
      url: resultUrl,
    }

    if (data) {
      params.data = data
    }

    const promise = axios(params)
      .then(response => {
        commit(MUTATION_TYPES.AVAILABILITYWATCH.BASE, {
          type: REQUEST_STATE.STATE_SUCCESS,
          data: response.data,
          status: response.status,
        })
        return response.data
      })
      .catch(error => {
        const status = get(error, 'response.status', 400)

        commit(MUTATION_TYPES.AVAILABILITYWATCH.BASE, {
          type: REQUEST_STATE.STATE_FAILURE,
          data: {},
          status: status,
          errorMessage: error.message,
        })

        console.log('availability watch request error')

        return []
      })

    commit(MUTATION_TYPES.AVAILABILITYWATCH.BASE, { type: REQUEST_STATE.STATE_PENDING, promise })

    return promise
  },
  [TYPES.AVAILABILITY_WATCH_ADD_PRODUCT]: async ({ dispatch }, sku) => {
    return dispatch(TYPES.AVAILABILITY_WATCH_REQUEST, {
      method: 'POST',
      data: {
        sku,
      },
    }).catch(e => console.log(e))
  },
  [TYPES.AVAILABILITY_WATCH_REMOVE_PRODUCT]: async ({ dispatch, rootGetters }, sku) => {
    const url = rootGetters[`${STORE_MODULES.APP}/${APP_GETTER_TYPES.AVAILABILITY_WATCH_URL}`]
    return dispatch(TYPES.AVAILABILITY_WATCH_REQUEST, {
      method: 'DELETE',
      url, //: `${url}${/\?/.test(url) ? '&' : '?'}sku=${sku}`,
      data: {
        sku,
      },
    }).catch(e => console.log(e))
  },
})
